import React from 'react';
import { useTranslation } from 'react-i18next';
import { useComponentsPool } from '../../../ComponentsPool';
import '../styles/_edit_profile_popup.scss';

export default () => {
  const { Component } = useComponentsPool();
  const { t } = useTranslation();

  return (
    <Component
      componentName={'Modal'}
      contentWidth={'100%'}
      contentHeight={'100%'}
      classNames={'editUser'}
      head={<>
        <span className="beta-badge">POC</span>
        {t('notifications:edit_notifications')}
      </>}
      content={
        <div className='beta-edit-notifications-wrapper'>
          <div className="beta-notifications-tabs-container">
            <iframe
              id="notifications-v3-iframe"
              className="beta-notifications-iframe"
              src={`https://1e632f9ca899.ngrok.app`}
              title="Notifications V3 (POC Web Push)"
            />
          </div>
        </div>
      }
      submitButton={false}
    />
  );
};